import { render, staticRenderFns } from "./TreeStructure.vue?vue&type=template&id=b7bf47ec&scoped=true&"
import script from "./TreeStructure.vue?vue&type=script&lang=js&"
export * from "./TreeStructure.vue?vue&type=script&lang=js&"
import style0 from "./TreeStructure.vue?vue&type=style&index=0&id=b7bf47ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf47ec",
  null
  
)

export default component.exports